module.exports = __webpack_public_path__ + "static/media/youssef_mehelba.528fec66.png";